// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ModalWindow-module_modalContainer__FIEEB {
    background-color: var(--color-white);
    bottom: 0;
    left: 0;
    min-width: 288px;
    position: fixed;
    right: 0;
    top: 0;
    z-index: 2000;
}

.ModalWindow-module_modalViewport__lfvLA {
    background-color: var(--color-white);
    bottom: 0;
    left: 0;
    position: absolute;
    right: 0;
    top: 0;
    overflow-x: hidden;
    overflow-y: auto;
}

.ModalWindow-module_modalBody__GS1rt {
    padding: 72px 0 0 0;
    margin: 0 auto;
    max-width: 100%;
    min-height: 100%;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
}

@media screen and (min-width: 481px) {
    .ModalWindow-module_modalBody__GS1rt {
        max-width: 480px;
    }
}

@media screen and (min-width: 708px) {
    .ModalWindow-module_modalBody__GS1rt {
        padding: 104px 0;
        max-width: calc(((100% - 168px) / 6) * 4 + 120px);
    }
}

@media screen and (min-width: 889px) {
    .ModalWindow-module_modalBody__GS1rt {
        max-width: 600px;
    }
}
`, "",{"version":3,"sources":["webpack://./../../libs/core/src/components/Popup/ModalWindow.module.css"],"names":[],"mappings":"AAAA;IACI,oCAAoC;IACpC,SAAS;IACT,OAAO;IACP,gBAAgB;IAChB,eAAe;IACf,QAAQ;IACR,MAAM;IACN,aAAa;AACjB;;AAEA;IACI,oCAAoC;IACpC,SAAS;IACT,OAAO;IACP,kBAAkB;IAClB,QAAQ;IACR,MAAM;IACN,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,aAAa;IACb,sBAAsB;IACtB,2BAA2B;AAC/B;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI,gBAAgB;QAChB,iDAAiD;IACrD;AACJ;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ","sourcesContent":[".modalContainer {\n    background-color: var(--color-white);\n    bottom: 0;\n    left: 0;\n    min-width: 288px;\n    position: fixed;\n    right: 0;\n    top: 0;\n    z-index: 2000;\n}\n\n.modalViewport {\n    background-color: var(--color-white);\n    bottom: 0;\n    left: 0;\n    position: absolute;\n    right: 0;\n    top: 0;\n    overflow-x: hidden;\n    overflow-y: auto;\n}\n\n.modalBody {\n    padding: 72px 0 0 0;\n    margin: 0 auto;\n    max-width: 100%;\n    min-height: 100%;\n    box-sizing: border-box;\n    display: flex;\n    flex-direction: column;\n    justify-content: flex-start;\n}\n\n@media screen and (min-width: 481px) {\n    .modalBody {\n        max-width: 480px;\n    }\n}\n\n@media screen and (min-width: 708px) {\n    .modalBody {\n        padding: 104px 0;\n        max-width: calc(((100% - 168px) / 6) * 4 + 120px);\n    }\n}\n\n@media screen and (min-width: 889px) {\n    .modalBody {\n        max-width: 600px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modalContainer": `ModalWindow-module_modalContainer__FIEEB`,
	"modalViewport": `ModalWindow-module_modalViewport__lfvLA`,
	"modalBody": `ModalWindow-module_modalBody__GS1rt`
};
export default ___CSS_LOADER_EXPORT___;
